module.exports = __webpack_public_path__ + "static/media/anage-negocios@2x.2d8da65b.png";